// Italian translations for Hipro Technologies
const it = {
  meta: { code: 'it', name: 'Italiano', flag: '🇮🇹' },

  nav: {
    home: 'Home', about: 'Chi siamo', services: 'Servizi', portfolio: 'Portfolio',
    pricing: 'Prezzi', industries: 'Settori', insights: 'Approfondimenti', contact: 'Contatti',
    bookFreeCall: 'Chiamata gratuita',
  },

  common: {
    getFreeConsultation: 'Consulenza gratuita',
    exploreServices: 'Esplora i servizi',
    viewDetails: 'Dettagli',
    bookAppointment: 'Prenota appuntamento gratuito',
    choosePackage: 'Scegli il pacchetto',
    scheduleCall: 'Prenota una chiamata',
    talkToSales: 'Parla con le vendite',
    readArticle: 'Leggi articolo',
    viewAllPortfolio: 'Tutto il portfolio',
    viewAllInsights: 'Tutti gli approfondimenti',
    requestCustomQuote: 'Richiedi preventivo',
    backHome: 'Torna alla home',
    backToPortfolio: 'Torna al portfolio',
    trustedWorldwide: 'Scelti da aziende in tutto il mondo',
    isoCertified: 'Certificati ISO 27001 e ISO 9001',
    all: 'Tutti',
    allIndustries: 'Tutti i settori',
    industryLabel: 'Settore',
    chatOnWhatsapp: 'Chat su WhatsApp',
    submitting: 'Invio in corso…',
    loading: 'Caricamento…',
  },

  hero: {
    badge: 'Azienda tecnologica certificata ISO/IEC 27001:2022 e ISO 9001:2015',
    titleA: 'Software basato su', titleB: 'AI', titleC: ',',
    titleD: 'Cloud e crescita digitale', titleE: 'Partner', titleF: '.',
    subtitleLead: 'Scelti da aziende in',
    countries: 'USA, UK, Emirati Arabi, Paesi Bassi, Malesia, Hong Kong e India',
    subtitleRest: 'per costruire, crescere e scalare più velocemente. Da software su misura e siti web ad automazioni AI, SEO e app mobili — realizziamo soluzioni digitali che generano lead, aumentano il fatturato e accelerano la crescita.',
    stats: {
      years: 'Anni di esperienza', offices: 'Sedi globali',
      projects: 'Progetti realizzati', retention: 'Retention clienti',
    },
  },

  form: {
    title: 'Parla con un esperto',
    subtitle: 'Ricevi una consulenza GRATUITA e un preventivo entro 24 ore.',
    ribbon: 'Chiamata strategica gratuita',
    name: 'Nome*', namePh: 'Nome e cognome',
    email: 'Email*', emailPh: 'tu@azienda.com',
    mobile: 'Cellulare*', mobilePh: 'Numero di cellulare',
    selectService: 'Seleziona servizio*', servicePh: '---- Seleziona servizio ----',
    hear: 'Come ci hai conosciuto?*', hearPh: '---- Seleziona ----',
    submit: 'Prenota chiamata gratuita',
    success: 'Richiesta ricevuta',
    successDesc: 'Un consulente Hipro ti contatterà entro 24 ore.',
    validation: 'Compila i campi obbligatori',
    validationDesc: 'Nome, email e cellulare sono obbligatori.',
    error: 'Invio non riuscito',
  },

  about: {
    kicker: 'Fondata nel 2015. Guidata da leader con esperienza dal 2010.',
    titleA: 'Scelti da aziende',
    titleB: 'in tutto il mondo',
    body: 'Negli ultimi dieci anni, Hipro Technologies ha aiutato aziende a progettare e costruire siti web, piattaforme software e prodotti digitali in molteplici settori. Con team in USA, UK, Emirati Arabi, Paesi Bassi, Malesia, Hong Kong e India, offriamo ingegneria di livello enterprise con partnership locale.',
    features: [
      { t: '7 Paesi', d: 'Centri di consegna in USA, UK, Emirati Arabi, Paesi Bassi, Malesia, Hong Kong e India.' },
      { t: 'Certificati ISO', d: 'Processi certificati ISO/IEC 27001:2022 e ISO 9001:2015.' },
      { t: 'Delivery agile', d: 'Sprint di due settimane con daily e reportistica trasparente.' },
      { t: 'Supporto 24/7', d: 'Ingegneria follow-the-sun con SLA garantiti.' },
    ],
    stats: [
      { label: 'Progetti digitali' }, { label: 'Professionisti tecnologici nel mondo' },
      { label: 'Clienti serviti' }, { label: 'Mercati globali' },
    ],
    gapKicker: 'Il 96% delle aziende affronta questo gap…',
    gapTitle: 'Idee forti, esecuzione debole.',
    gapBody: 'Non siamo un’azienda che consegna deliverable. Siamo il vostro partner di crescita — possediamo i risultati, dalla strategia al lancio.',
  },

  services: {
    kicker: 'Servizi IT end-to-end',
    title: 'Web, Software e Digital Marketing',
    body: 'Dall’idea all’esecuzione, Hipro Technologies aiuta le aziende a costruire esperienze digitali potenti che attraggono clienti, ottimizzano le operazioni e generano crescita di lungo termine.',
    childServices: 'Servizi inclusi',
    items: {
      design: {
        tag: 'Creativo',
        title: 'Design & Creatività',
        subtitle: 'Creiamo esperienze digitali belle e intuitive.',
        list: ['Web Design', 'Graphic Design', 'UI/UX Design', 'Brand & Identità', 'Video Production', 'Creativi social', 'Motion Graphics'],
      },
      development: {
        tag: 'Popolare',
        title: 'Sviluppo & Tecnologia',
        subtitle: 'Applicazioni e sistemi robusti e scalabili.',
        list: ['App Mobili', 'eCommerce', 'Software su Misura', 'Web Application', 'Soluzioni ERP/CRM', 'Integrazioni API', 'Sviluppo SaaS'],
      },
      marketing: {
        tag: 'Molto richiesto',
        title: 'Marketing & Crescita',
        subtitle: 'Strategie data-driven per scalare il tuo business.',
        list: ['Digital Marketing', 'Performance Marketing', 'SEO & GEO', 'Meta Ads', 'Google Ads', 'Lead Generation', 'Social Media', 'Content Marketing'],
      },
      ai_automation: {
        tag: 'AI',
        title: 'AI & Automazione',
        subtitle: 'Sistemi intelligenti che riducono i costi e accelerano la crescita.',
        list: ['Chatbot e assistenti AI', 'Automazione dei processi', 'Document Intelligence (OCR + LLM)', 'Screening AI di candidati e lead', 'Analisi predittiva e modelli ML', 'Integrazione e fine-tuning LLM'],
      },
      custom_software: {
        tag: 'Su misura',
        title: 'Software Personalizzato',
        subtitle: 'Software costruito attorno ai tuoi flussi di lavoro.',
        list: ['Discovery e architettura', 'Piattaforme SaaS', 'Tool e portali interni', 'API e integrazioni', 'Sistemi multi-tenant', 'QA e test automation'],
      },
      cloud_devops: {
        tag: 'Scalabile',
        title: 'Cloud & DevOps',
        subtitle: 'Infrastrutture affidabili, sicure e ottimizzate nei costi.',
        list: ['Architettura AWS / Azure / GCP', 'Kubernetes e container', 'Pipeline CI/CD', 'Infrastructure as Code (Terraform)', 'Monitoring e observability', 'Ottimizzazione costi cloud'],
      },
      data_analytics: {
        tag: 'Data-driven',
        title: 'Dati & Analytics',
        subtitle: 'Trasforma i dati grezzi in decisioni affidabili.',
        list: ['Data warehouse e pipeline', 'Dashboard di Business Intelligence', 'Ingegneria ETL / ELT', 'Analytics in tempo reale', 'Data governance e qualità', 'Customer 360 e reportistica'],
      },
      cybersecurity: {
        tag: 'Sicuro',
        title: 'Cybersecurity',
        subtitle: 'Proteggi applicazioni, dati e reputazione.',
        list: ['Audit di sicurezza e pen testing', 'SDLC sicuro e code review', 'Identity & Access Management', 'Conformità SOC 2 / ISO 27001 / GDPR', 'Gestione vulnerabilità', 'Piani di incident response'],
      },
      app_modernization: {
        tag: 'Future-proof',
        title: 'Modernizzazione Applicativa',
        subtitle: 'Porta i sistemi legacy su stack moderni e manutenibili.',
        list: ['Audit legacy e roadmap', 'Da monolite a microservizi', 'Migrazione e re-platforming cloud', 'Revamp UI/UX di app legacy', 'Modernizzazione database', 'Migrazione senza downtime'],
      },
      enterprise_solutions: {
        tag: 'Enterprise',
        title: 'Soluzioni Enterprise',
        subtitle: 'Piattaforme mission-critical per grandi organizzazioni.',
        list: ['Implementazione ERP e CRM', 'Sistemi HRMS e payroll', 'Piattaforme supply chain e logistica', 'Integrazioni enterprise (SAP, Salesforce)', 'Workflow engine personalizzati', 'Accessi e compliance basati su ruoli'],
      },
      managed_it: {
        tag: '24/7',
        title: 'Servizi IT Gestiti',
        subtitle: 'Il tuo team tecnologico sempre attivo, senza costi fissi.',
        list: ['Monitoraggio e supporto 24/7', 'Manutenzione con SLA', 'Helpdesk e ticketing', 'Gestione patch e release', 'Backup e disaster recovery', 'Ingegneri di supporto dedicati'],
      },
    },
  },

  portfolio: {
    kicker: 'Portfolio',
    title: 'Progetti recenti e casi di successo',
    empty: 'Nessun case study corrisponde ai filtri selezionati. Prova a rimuoverli.',
  },

  tech: {
    kicker: 'Tech Stack & Strumenti',
    title: 'Le tecnologie che usiamo',
    body: 'Utilizziamo linguaggi moderni, pacchetti e tecniche cloud per costruire esperienze digitali scalabili.',
  },

  industries: {
    kicker: 'Le nostre competenze',
    title: 'Settori che serviamo',
    body: 'Soluzioni software specialistiche per settori diversi con profonda esperienza di dominio.',
    customKicker: 'Requisiti speciali?',
    customTitle: 'Non vedi il tuo settore?',
    customBody: 'Progettiamo soluzioni software su misura per molti altri settori specializzati.',
    items: {
      healthcare: { name: 'Sanità', desc: 'Software sanitario HIPAA-compliant, telemedicina e piattaforme EHR.' },
      education: { name: 'Educazione', desc: 'LMS moderni, e-learning e sistemi per la gestione scolastica.' },
      finance: { name: 'Finanza', desc: 'Prodotti fintech sicuri, banking e wealth management.' },
      retail: { name: 'Retail', desc: 'eCommerce moderno, POS e soluzioni omnichannel.' },
      manufacturing: { name: 'Manifattura', desc: 'Automazione intelligente e software Industry 4.0.' },
      realestate: { name: 'Immobiliare', desc: 'Gestione immobili, portali di annunci e CRM.' },
      travel: { name: 'Viaggi', desc: 'Piattaforme OTA, motori di prenotazione e travel management.' },
      automotive: { name: 'Automotive', desc: 'Piattaforme dealer, flotte e veicoli connessi.' },
      technology: { name: 'Tecnologia', desc: 'Piattaforme SaaS, strumenti dev e software enterprise.' },
    },
  },

  process: {
    kicker: 'Workflow Agile Comprovato',
    title: 'Come lavoriamo',
    body: 'Un processo agile affidabile per consegnare siti e app digitali scalabili, sicuri e ad alte prestazioni.',
    steps: {
      '01': { tag: 'Discovery & Scope', title: 'Analisi dei requisiti', items: ['Analisi business', 'Utenti target', 'Requisiti', 'Scope del progetto'] },
      '02': { tag: 'Wireframe & UI', title: 'Processo UI/UX', items: ['Wireframing', 'UI Design', 'Prototyping', 'User testing'] },
      '03': { tag: 'Sviluppo Full-Stack', title: 'Sviluppo applicazione', items: ['Qualità del codice', 'Version control', 'Best practice', 'Test integrati'] },
      '04': { tag: 'QA & Sicurezza', title: 'Testing di qualità', items: ['Test funzionali', 'Performance', 'Sicurezza', 'Device testing'] },
      '05': { tag: 'Store & Cloud', title: 'Deploy', items: ['Submission Store', 'App review', 'ASO', 'Lancio'] },
      '06': { tag: 'Supporto 24/7', title: 'Supporto e scaling', items: ['Bug fix', 'Aggiornamenti', 'Scaling', 'Supporto'] },
    },
    stepPrefix: 'Step',
  },

  insights: {
    kicker: 'Ultime novità', title: 'Approfondimenti & News',
    body: 'Insight esperti su digital marketing, SEO, AI e crescita aziendale dal team di Hipro.',
  },

  faq: {
    kicker: 'Domande frequenti?', title: 'Domande frequenti',
    body: 'Tutto quello che devi sapere sui nostri servizi, processi e su come acceleriamo la tua crescita digitale.',
    clientKicker: 'Voci dei clienti', clientTitle: 'Cosa dicono i clienti di Hipro',
    shareYours: 'Condividi la tua',
  },

  cta: {
    kicker: 'Pronto a iniziare?',
    titleA: 'Costruiamo la tua', titleB: 'storia di crescita', titleC: 'insieme',
    body: 'Il momento migliore per portare il tuo business online è adesso. Scegli il pacchetto giusto e parla direttamente con i nostri esperti su WhatsApp.',
  },

  contactMap: {
    kicker: 'Dove siamo',
    title: 'Visita la sede più vicina',
    body: '13 sedi tra India, USA, Regno Unito, Emirati Arabi, Malesia, Paesi Bassi e Hong Kong. Seleziona una sede per vederla sulla mappa e ottenere le indicazioni con un tocco.',
    directions: 'Indicazioni stradali',
    nearest: 'Più vicino a te',
    useMyLocation: 'Usa la mia posizione',
  },

  footer: {
    globalKicker: 'Presenza globale',
    globalTitle: 'Le nostre sedi nel mondo',
    globalSub: '13 sedi in 7 Paesi — trova il team Hipro più vicino a te.',
    globalAll: 'Tutti i Paesi',
    officesLabel: 'Sedi',
    countriesLabel: 'Paesi',
    tagline: 'Hipro Technologies è un’azienda IT globale certificata ISO che offre ingegneria software, automazione AI, cloud e risultati di marketing digitale per aziende ambiziose.',
    servicesTitle: 'Servizi', companyTitle: 'Azienda', contactTitle: 'Contatti',
    servicesList: ['Web Development', 'Sviluppo App Mobili', 'Software su Misura', 'AI & Automazione', 'Cloud & DevOps', 'Dati & Analytics', 'Cybersecurity', 'Modernizzazione Applicativa', 'Soluzioni Enterprise', 'Servizi IT Gestiti', 'Digital Marketing & SEO'],
    companyList: ['Chi siamo', 'Portfolio', 'Settori', 'Approfondimenti', 'Lavora con noi', 'Contatti'],
    rightsReserved: 'Tutti i diritti riservati.',
    privacy: 'Privacy', terms: 'Termini di servizio', cookies: 'Cookie',
  },

  book: {
    kicker: 'Prenota un incontro',
    title: 'Scegli l’orario. Portiamo noi le idee.',
    body: 'Chiamata strategica di 30 minuti con un consulente senior. Nessuna pressione — solo prossimi passi chiari.',
    pickDate: 'Scegli una data', pickSlot: 'Slot disponibili il',
    loadingSlots: 'Caricamento slot…',
    slotNote: 'Gli slot sono in IST (ora indiana). L\'equivalente locale appare sotto ogni slot — ✓ indica un orario comodo per te.',
    fullName: 'Nome completo *', workEmail: 'Email di lavoro *', phone: 'Telefono', timezone: 'Fuso orario',
    help: 'Come possiamo aiutarti?', helpPh: 'Seleziona un servizio',
    notes: 'Qualcosa da aggiungere?', notesPh: 'Fase del progetto, obiettivi, tempi…',
    yourBooking: 'La tua prenotazione', pickSlotPlaceholder: 'Scegli uno slot',
    autoTz: 'Fuso orario rilevato', nearest: 'Sede più vicina', yourTime: 'ora tua',
    confirm: 'Conferma incontro', confirming: 'Conferma in corso…',
    disclaimer: 'Prenotando, accetti di ricevere un invito calendar e email di follow-up da Hipro Technologies. Niente spam.',
    booked: 'Sei prenotato!',
    bookedBody: 'Un invito calendar è stato riservato per te. Aggiungilo al calendario per non dimenticare.',
    downloadIcs: 'Scarica invito .ics',
    backToHome: 'Torna alla home',
    reminder: 'Ti contatteremo via email con il link della riunione e un breve brief.',
    confirmedToast: 'Incontro confermato!',
    confirmedToastDesc: 'Controlla l’email per i dettagli. Aggiungi l’evento al calendario.',
    slotTaken: 'Slot appena prenotato',
    slotTakenDesc: 'Lo slot è stato preso. Scegline un altro.',
  },

  pricing: {
    kicker: 'Prezzi trasparenti',
    title: 'Pacchetti nella tua valuta locale',
    body: 'Rilevata dalla tua posizione. Cambia in qualsiasi momento — lavoriamo con clienti in USA, UK, EU, Emirati Arabi, Malesia, Hong Kong e India.',
    pricesShownIn: 'Prezzi in',
    fxNote: 'approssimativi, basati sui tassi di cambio odierni.',
    mostPopular: 'Il più scelto',
    bestFor: 'Ideale per:', delivery: 'Consegna:',
    taxes: 'Tasse escluse. Enterprise e retainer di lungo periodo sono personalizzati — prenota una chiamata per una proposta dettagliata.',
  },

  testimonial: {
    hero: 'Racconta la tua storia con Hipro',
    subtitle: 'Ti è piaciuto lavorare con noi? Inviaci una testimonianza. Le nuove submission vengono moderate prima della pubblicazione.',
    yourName: 'Il tuo nome *', role: 'Ruolo', company: 'Azienda', country: 'Paese',
    feedback: 'Il tuo feedback *', feedbackPh: 'Cosa ha funzionato e cosa possiamo migliorare…',
    rating: 'Valutazione',
    photo: 'La tua foto (opzionale)', logo: 'Logo azienda (opzionale)',
    submit: 'Invia testimonianza',
    thankTitle: 'Grazie!',
    thankBody: 'La tua testimonianza è in revisione e apparirà una volta approvata.',
    almost: 'Quasi fatto', almostBody: 'Inserisci almeno nome e una breve citazione.',
    tooLarge: 'Immagine troppo grande', tooLargeBody: 'Mantieni sotto 1.2MB.',
  },

  caseStudy: {
    problem: 'Il Problema',
    solution: 'La Soluzione',
    outcomes: 'Risultati misurabili',
    techStack: 'Tech Stack',
    similar: 'Hai un progetto simile?',
    similarBody: 'Ottieni una consulenza gratuita e un preventivo entro 24 ore.',
    bookCall: 'Prenota una chiamata', seePricing: 'Vedi prezzi',
    team: 'Team', duration: 'Durata', client: 'Cliente', industry: 'Settore',
    notFound: 'Case study non trovato', notFoundBody: 'Il progetto che cerchi non esiste o è stato spostato.',
  },
};

export default it;
